// extracted by mini-css-extract-plugin
module.exports = {"hidden":"reconnectIndicator_hidden__3zYcu","visible":"reconnectIndicator_visible__1VKYk","block":"reconnectIndicator_block__2Jow-"};